import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_PROGRESS_BILLINGS = 'GET_PROGRESS_BILLINGS';
export const GET_PROGRESS_BILLING = 'GET_PROGRESS_BILLING';
export const CREATE_PROGRESS_BILLING = 'CREATE_PROGRESS_BILLING';
export const UPDATE_PROGRESS_BILLING = 'UPDATE_PROGRESS_BILLING';
export const DELETE_PROGRESS_BILLING = 'DELETE_PROGRESS_BILLING';
export const APPROVE_PROGRESS_BILLING = 'APPROVE_PROGRESS_BILLING';
export const REJECT_PROGRESS_BILLING = 'REJECT_PROGRESS_BILLING';
export const SUBMIT_PROGRESS_BILLING = 'SUBMIT_PROGRESS_BILLING';
export const GET_PROJECT_BILLING_SUMMARY = 'GET_PROJECT_BILLING_SUMMARY';

// Get all progress billings
export const getProgressBillings = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchProgressBillings(searchQuery, page, pageSize);
    
    dispatch({ type: GET_PROGRESS_BILLINGS, payload: data });
    return data;
  } catch (error) {
    console.error('Error fetching progress billings:', error);
    throw error;
  }
};

// Get single progress billing
export const getProgressBilling = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchProgressBilling(id);
    
    dispatch({ type: GET_PROGRESS_BILLING, payload: data });
    return data;
  } catch (error) {
    console.error('Error fetching progress billing:', error);
    throw error;
  }
};

// Create progress billing
export const createProgressBilling = (billingData, openSnackbar, history, currentLang) => async (dispatch) => {
  try {
    const { data } = await api.createProgressBilling(billingData);
    
    dispatch({ type: CREATE_PROGRESS_BILLING, payload: data });
    openSnackbar('Progress billing created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Progress billing created successfully"));
    const projectId = data.projectId?._id || data.projectId;
    if (projectId) {
      history.push(`/${currentLang}/app/construction/projects/${projectId}/progress-billing`);
    }
    
    return data;
  } catch (error) {
    console.error('Error creating progress billing:', error);
    openSnackbar('Error creating progress billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating progress billing"));
    throw error;
  }
};

// Update progress billing
export const updateProgressBilling = (id, billingData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateProgressBilling(id, billingData);
    
    dispatch({ type: UPDATE_PROGRESS_BILLING, payload: data });
    openSnackbar('Progress billing updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Progress billing updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating progress billing:', error);
    openSnackbar('Error updating progress billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating progress billing"));
    throw error;
  }
};

// Delete progress billing
export const deleteProgressBilling = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteProgressBilling(id);
    
    dispatch({ type: DELETE_PROGRESS_BILLING, payload: id });
    openSnackbar('Progress billing deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Progress billing deleted successfully"));
  } catch (error) {
    console.error('Error deleting progress billing:', error);
    openSnackbar('Error deleting progress billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting progress billing"));
    throw error;
  }
};

// Submit progress billing
export const submitProgressBilling = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.submitProgressBilling(id);
    
    dispatch({ type: SUBMIT_PROGRESS_BILLING, payload: data });
    openSnackbar('Progress billing submitted for approval', SNACKBAR_DURATION_MS, getSnackbarColor("Progress billing submitted for approval"));
    
    return data;
  } catch (error) {
    console.error('Error submitting progress billing:', error);
    openSnackbar('Error submitting progress billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error submitting progress billing"));
    throw error;
  }
};

// Approve progress billing
export const approveProgressBilling = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveProgressBilling(id);
    
    dispatch({ type: APPROVE_PROGRESS_BILLING, payload: data });
    openSnackbar('Progress billing approved and invoice generated', SNACKBAR_DURATION_MS, getSnackbarColor("Progress billing approved and invoice generated"));
    
    return data;
  } catch (error) {
    console.error('Error approving progress billing:', error);
    openSnackbar('Error approving progress billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error approving progress billing"));
    throw error;
  }
};

// Reject progress billing
export const rejectProgressBilling = (id, rejectionReason, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.rejectProgressBilling(id, { rejectionReason });
    
    dispatch({ type: REJECT_PROGRESS_BILLING, payload: data });
    openSnackbar('Progress billing rejected', SNACKBAR_DURATION_MS, getSnackbarColor("Progress billing rejected"));
    
    return data;
  } catch (error) {
    console.error('Error rejecting progress billing:', error);
    openSnackbar('Error rejecting progress billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error rejecting progress billing"));
    throw error;
  }
};

// Get project billing summary
export const getProjectBillingSummary = (projectId) => async (dispatch) => {
  try {
    const { data } = await api.getProjectBillingSummary(projectId);
    
    dispatch({ type: GET_PROJECT_BILLING_SUMMARY, payload: data });
    return data;
  } catch (error) {
    console.error('Error fetching project billing summary:', error);
    throw error;
  }
};
